export const environment = {
	production: false,
	env: 'development',
	theme: 'app-theme',
};